import React from 'react';
import _ from 'lodash';
import { imagesURL } from 'config';

export default (buttons, globalButtons, translate) => {
  const slots = {};

  buttons.forEach((btn) => {
    const btnObject = typeof btn === 'string' ? { type: btn } : btn;
    const btnDataFromDB = _.find(globalButtons, { alias: btnObject.type });

    if (!btnDataFromDB || btnObject.dontShow) return;

    const backgroundImage = `url(${imagesURL}/GlobalButtons/${btnDataFromDB.imageFilename})`;
    const position = btnDataFromDB.position;

    const buttonHtml = (
      <button
        key={btnDataFromDB.alias}
        type='button'
        onClick={() => {
          if (btn.beforeClickHandler) {
            btn.beforeClickHandler(btn.onClick);
          } else {
            btn.onClick();
          }
        }}
        disabled={btnObject.disabled}
        title={translate(btnDataFromDB.stringNumber, btnDataFromDB.name, true)}
        style={{ backgroundImage }}
      />
    );

    if (!slots[position]) slots[position] = [];
    slots[position].push({
      html: buttonHtml,
      name: btnDataFromDB.name
    });
  });

  const finalResult = [];

  for (let i = 1; i <= 7; i++) {
    if (slots[i]) {
      const sorted = _.orderBy(slots[i], ['name'], ['asc']);
      sorted.forEach(item => finalResult.push(item.html));
    } else {
      finalResult.push(null);
    }
  }

  return finalResult;
};